import DashboardContainer from "./DashboardContainer";
import { orgDashboardContainer } from "../../container/orgDashboard.container";

const Dashboard = () => {
  const { modelState, ...rest } = orgDashboardContainer();
  return <DashboardContainer {...{ modelState, ...rest }} />;
};
export default Dashboard;
